export default "__VITE_ASSET__DXJKLqG8__"